import { ApolloClient, ApolloLink, createHttpLink, from, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { handleAuthError } from "./authErrorHandler";
//LIBS & CONSTANTS

const REACT_APP_API_URL = process.env[`REACT_APP_API_URL`];
const REACT_APP_GRAPH_ENDPOINT = process.env[`REACT_APP_GRAPH_ENDPOINT`];

const httpLink = createHttpLink({
    uri: `${REACT_APP_API_URL}/${REACT_APP_GRAPH_ENDPOINT}`,
});

const authLink = setContext(async (_, { headers }) => {
    const token = JSON.parse((await localStorage.getItem("token")) || "{}");
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token.accessToken}` : "",
        },
    };
});
/**
 * The auth part of this handler lives in authErrorHandler.ts so it can be tested without an
 * ApolloClient.
 */
const error = onError(({ graphQLErrors, networkError }) => {
    try {
        if (graphQLErrors && graphQLErrors[0] !== null) {
            void handleAuthError(graphQLErrors);

            console.error(
                "🚀 ~ file: apolloClient.tsx ~ errorMessage",
                graphQLErrors.map(({ message }) => `${message} `)
            );
        }

        if (networkError) console.error(`[Network error]: ${networkError}`);
    } catch (error) {
        // This is the error link, so nothing above it would catch an exception thrown while reporting.
        console.error("[Apollo error link failed]:", error);
    }
});


const timeStartLink = new ApolloLink((operation, forward) => {
    operation.setContext({ start: performance.now() })
    return forward(operation)
  })
  
  const logTimeLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(data => {
      // data from a previous link
      const time = performance.now() - operation.getContext().start;

      const requestTime = JSON.parse(
        localStorage.getItem("responseTimeObj") || "{}"
        );
        requestTime[operation.operationName] = Number(time.toFixed(2));
        localStorage.setItem(
            "responseTimeObj",
            JSON.stringify(requestTime)
        );
        return data
    })
  })
  
  const responseTimeLogger = timeStartLink.concat(logTimeLink)

const cache = new InMemoryCache({});

const apolloClient = new ApolloClient({
    // link: error.concat(authLink.concat(httpLink)),
    link: from([error, responseTimeLogger, authLink.concat(httpLink)]),
    cache: cache,
    defaultOptions: {
        mutate: { errorPolicy: "all" },
        query: { errorPolicy: "all" },
    },    
});

export default apolloClient;

export type { AHAGraphQLError } from "./authErrorHandler";
